/* @flow */

import glamorous from 'glamorous';
import colorUtils from 'color';

const Sidebar = glamorous.div(props => ({
  backgroundColor: props.nobackground ? 'inherit' : colorUtils(props.theme.color.basis1),
  height: props.top ? `calc(100vh - ${props.top})` : '100vh',
  left: props.location === 'left' ? 0 : 'auto',
  overflow: 'hidden',
  position: 'fixed',
  right: props.location === 'right' ? 0 : 'auto',
  top: props.top || 0,
  zIndex: 9,
}));

export default Sidebar;
